<template>
  <div id="discountPopup" :class="showPopup ? 'show' : ''">
    <div class="content">
    <div class="close" @click="closePopup">×</div>
      <div class="ticket">
        <div class="ticket-border-left"></div>
        <div class="ticket-content">
          <p class="top">Take an extra discount</p>
          <h1>10% OFF</h1>
          <h6 style="margin: 5px 0 15px;">For orders above 10£</h6>
          <p class="bottom">
            <span>Voucher code</span><br>
            V21CU23
          </p>
          <b-button class="btn-danger btn-fill" @click="setDiscount">Use Now</b-button>
        </div>
        <div class="ticket-border-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  let kf

  export default {
    name: 'discount-popup',
    props: ['popupAfterTime'],
    computed: {
      ...mapState({
        discount: state => state.discount
      })
    },
    mounted () {
      kf = this

      if (this.discount.type) {
        return
      }

      setTimeout(function () {
        if (kf.discount.type) {
          return
        }

        kf.showPopup = true
      }, this.popupAfterTime ? this.popupAfterTime * 1000 : 10000)
    },
    data () {
      return {
        showPopup: null
      }
    },
    methods: {
      closePopup: () => {
        kf.showPopup = false
      },
      setDiscount: () => {
        kf.$store.dispatch('UpdateDiscount', {
          code: 'V21CU23',
          discount: 10,
          type: '%'
        })
        kf.closePopup()

        kf.notifyVue('success', 'Your 10% discount has been applied. Now add products to your cart and enjoy the food!')

        kf.$router.push({ name: 'menu' })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// discount-popup.vue?3411f018